import React, { useEffect, useRef } from 'react';
import { compose } from 'ramda';
import moment from 'moment';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from '@synergycms_core/components/generic/Datepicker/datepicker.js';
import RichText from '@synergycms_core/components/generic/RichText';
import { Button } from '@synergycms_core/components/generic/';
import classnames from 'classnames/bind';
import Select from 'react-select';

class DatepickerDaySelector extends React.Component {
  
  static displayName = 'DatepickerDaySelector';

  constructor(props) {
    super(props);
    this.cx = classnames.bind(props.theme.styles.classes);
    this.onOptionSelect = this.onOptionSelect.bind(this);
  }

  onOptionSelect = (selectedOption) => {
    const date = moment(`${this.props.config.stringDate} ${selectedOption.value}`);
    this.props.config.onOptionSelect && this.props.config.onOptionSelect(date);
    this.props.config.selectRange(this.props.config.day)();
  }

  render() {

    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const calendarColor = theme.themeValues.calendarColor || '#5CA70A';

    // day fields : day, stringDate, isSelected, startRange, endRange, disabled, 
    const { 
      day,
      stringDate,
      isSelected,
      currentDate,
      selectRange,
      daySelectorOptions,
      disabled,
      preSelected
    } = config;

    return (
      <Button
        onClick={selectRange(day)}
        innerStyle={[
          theme.styles.classes.day,
          theme.styles.classes.quotaServiceDay,
          !!day && currentDate === stringDate
            ? theme.styles.classes.today
            : theme.styles.classes.notToday,
          !!day &&
          this.cx({
            isSelected: isSelected,
            startRange: false,
            endRange: false,
            disabled: disabled,
            //preSelected: !!preSelected && !disabled
          })
        ]}
        disabled={disabled}>
        <div className={[classes.dayContainer].join(' ')}>
          {!!day && <RichText text={day.format("D")} innerStyle={[classes.dayText, day.format('YYYY-MM-DD')]} />}
        </div>
        {isSelected && day &&
          <SelectComponent
            onChange={this.onOptionSelect}
            selectRange={selectRange}
            day={day}
            calendarColor={calendarColor}
            options={day ? daySelectorOptions[day?.format('YYYY-MM-DD')] : []}
          />}
      </Button>
    );
  }
}

const SelectComponent = ({ options, onChange, selectRange, day, calendarColor }) => {
    
  const selectRef = useRef(null);
  const [menuIsOpen, setMenuIsOpen] = React.useState(true);

  useEffect(() => {
    const handleScroll = (e) => {
      if (!menuIsOpen) return;
      const select = selectRef.current;
      if(!select.contains(e.target)){
        setMenuIsOpen(false);
        selectRange(day)();
      }
    };

    const handleOutsideClick = (e) => {
      if (!menuIsOpen) return;
      const select = selectRef.current;
      if (!select.contains(e.target)) {
        setMenuIsOpen(false);
        selectRange(day)();
      }
    };
    window.addEventListener('scroll', handleScroll, true);
    window.addEventListener('click', handleOutsideClick, true);
    return () => {
      window.removeEventListener('click', handleOutsideClick, true);
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [menuIsOpen, day, selectRange]);
    
  return (
    <div ref={selectRef}>
      <Select
        options={options}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.value}
        isSearchable={false}
        onChange={onChange}
        menuIsOpen={menuIsOpen}
        styles={dropDownStyles({ calendarColor })}
      />
    </div>
  );
};


export default compose(
  PropertyManager([
    'day',
    'selectRange',
    'isSelected',
    'startRange',
    'endRange',
    'stringDate',
    'currentDate',
    'disabled',
    'dayTemplate',
    'datesSelected',
    'onOptionSelect',
    'daySelectorOptions',
    'preSelected',
  ]),
  withThemeJSS({ styleFile: styleFile.day, link: true })
)(DatepickerDaySelector);


const dropDownStyles = (options = {}) => {
  const { calendarColor } = options;
  return {
    container: (provided) => ({
      ...provided,
      position: 'absolute',
      top:'100%',
      '@media (min-width: 801px)': {
        top: '0',
        left: '100%'
      },
      width: '8em',
    }),
    control: (provided) => ({
      ...provided,
      display: 'none'
    }),
    menu: (provided) => ({
      ...provided,
      boxShadow: 'none',
      border: '1px solid #d8d8d8',
      width: 'unset',
      color: 'black',
      borderRadius: '0',
      marginTop: '0',
      backgroundColor: 'white',
      zIndex: '3',
    }),
    menuList: (provided) => ({
      ...provided,
      overflowX: 'hidden',
      maxHeight: '85px',
      paddingTop: '0',
      paddingBottom: '0',
      fontWeight: '300',
      fontSize: '11px',
      "::-webkit-scrollbar": {
        width: "8px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1"
      },
      "::-webkit-scrollbar-thumb": {
        background: "#b9b9b9"
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#888888"
      }
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected ? `${calendarColor}8A` : 'transparent',
      '&:hover':{
        background: `${calendarColor}8A`,
        fontWeight: 'bold',
      }
    })
  };
}